import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Winner", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Extras", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "+/- Exact Bonus", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 2 pts ")
const _hoisted_5 = {
  key: 0,
  class: "flex mt-2 gap-x-2"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Set as Current ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Generate and copy results")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Void ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Un-void ")

import { useWrestlerStore } from '@/store/wrestlers';
import { TEAM_NONE_ID, WRESTLER_NONE_ID } from '@/symbols/constants';
import {
  Match,
  MatchStatus,
  MatchResponse,
  ScorecardDisplayState,
  ScorecardViewMode,
} from '@/typings/scorecard';
import { Participant } from '@/typings/wrestler';
import { computed, inject, ref, Ref, toRefs } from 'vue';
import Extra from './Extra.vue';
import Participants from './Participants/Participants.vue';
import Winner from './Winner.vue';
import ScorecardSection from './ScorecardSection.vue';
import PotentialScore from './PotentialScore.vue';
import { useScorecardStore } from '@/store/scorecards';
import { AlertModal } from '@/typings/modal';

interface Props {
  match: Match;
  response: MatchResponse;
  correctResponse: MatchResponse;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    match: null,
    response: null,
    correctResponse: null,
    disabled: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  match: Match;
  response: MatchResponse;
  correctResponse: MatchResponse;
  disabled?: boolean;
}

const wrestlerStore = useWrestlerStore();
const scorecardStore = useScorecardStore();



const { match, response } = toRefs(props);

const wrestlers = computed((): Participant[] => {
  const visibleParticipants = match.value.Participants.filter(
    (p) => p.SuperstarId !== WRESTLER_NONE_ID
  );
  return visibleParticipants
    .map((v) => {
      const w = wrestlerStore.wrestlers.find(
        (wrestler) => wrestler.SuperstarId === v.SuperstarId
      );
      if (w) {
        return { Wrestler: w, ExtraText: v.ExtraText } as Participant;
      }
      return undefined;
    })
    .filter((x) => x !== undefined) as Participant[];
});

const teams = computed((): Participant[] => {
  const visibleTeams = match.value.Teams.filter(
    (p) => p.TeamId !== TEAM_NONE_ID
  );
  return visibleTeams
    .map((v) => {
      const t = wrestlerStore.teams.find(
        (wrestler) => wrestler.TeamId === v.TeamId
      );

      if (t) {
        return { Team: t, ExtraText: v.ExtraText } as Participant;
      }
      return undefined;
    })
    .filter((x) => x !== undefined) as Participant[];
});

const participants = computed((): Participant[] => [
  ...wrestlers.value,
  ...teams.value,
]);

const section = ref<InstanceType<typeof ScorecardSection> | null>(null);
const sectionUuid = computed(() =>
  !section.value ? '' : section.value.sectionUuid
);

expose({ sectionUuid });

const matchScore = computed(
  () =>
    match.value.Questions.length * match.value.ExtraPointValue +
    (match.value.HasWinner ? match.value.WinnerPointValue : 0) +
    match.value.Questions.filter((e) => e.Type === 'Number').length * 2
);

const resultsMode = inject('resultsMode');
const viewMode = inject('viewMode');

const { scorecard } = toRefs(scorecardStore);

const status = computed(() => {
  if (resultsMode) {
    return '';
  }
  if (scorecardStore.displayState === ScorecardDisplayState.View) {
    if (viewMode === ScorecardViewMode.Public) {
      return '';
    }
    return response.value.Score.toString();
  }

  try {
    const questions = response.value.Questions;
    let answers = 0;

    const len = response.value.Answer.toString().trim().length;
    if (len > 0) {
      answers += 1;
    }
    for (let i = 0; i < questions.length; i += 1) {
      if (
        questions[i].Answer !== null &&
        questions[i].Answer.toString().trim().length > 0
      ) {
        answers += 1;
      }
    }

    if (answers === 0) {
      return 'Incomplete';
    }

    if (answers === questions.length + (match.value.HasWinner ? 1 : 0)) {
      return 'Complete';
    }
  } catch (e) {
    console.error(e);
  }
  return 'In Progress';
});

function setAsCurrentMatch() {
  if (match.value.MatchId) {
    scorecardStore.setCurrentMatch(match.value.MatchId);
  }
}

const alertModal = inject('alertModal') as Ref<AlertModal>;
async function publishMatch() {
  if (match.value.MatchId) {
    const result = await scorecardStore.publishMatch(
      match.value.MatchId,
      response.value
    );
    navigator.clipboard.writeText(result).then(() => {
      alertModal.value.show(
        'Results generated',
        'Results have been generated and copied to your clipboard'
      );
    });
  }
}

function setMatchStatus(status: string) {
  if (match.value.MatchId) {
    scorecardStore.updateMatchStatus(match.value.MatchId, status);
  }
}

const $socket = inject('$socket');
$socket.on(
  'match-status',
  ({ status, slug, id }: { status: string; slug: string; id: number }) => {
    console.log(status, slug, id);
    if (slug === scorecard?.value?.event.Slug && match.value.MatchId == id) {
      match.value.Status = MatchStatus[status as keyof typeof MatchStatus];
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(ScorecardSection, {
    title: _unref(match).Title,
    subtitle: _unref(match).Subtitle,
    third: _unref(match).ThirdTitle,
    status: _unref(status),
    ref: (_value, _refs) => {
      _refs['section'] = _value
      section.value = _value
    },
    voided: _unref(match).Status === _unref(MatchStatus).Void
  }, {
    info: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass({
          'line-through text-gray-500': _unref(match).Status === _unref(MatchStatus).Void,
        })
      }, [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(_unref(match).WinnerPointValue) + " pts | ", 1),
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_unref(match).ExtraPointValue) + " pts | ", 1),
        _hoisted_3,
        _hoisted_4
      ], 2),
      (_unref(resultsMode))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(match).Status !== _unref(MatchStatus).Void)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(scorecard)?.event.CurrentMatch != _unref(match).MatchId)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        onClick: setAsCurrentMatch
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Button, { onClick: publishMatch }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (_unref(match).Status === _unref(MatchStatus).Open)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  style: {"text-decoration":"none !important"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (setMatchStatus(_unref(MatchStatus).Void)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(match).Status === _unref(MatchStatus).Void)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  style: {"text-decoration":"none !important"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setMatchStatus(_unref(MatchStatus).Open)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["ml-10", {
        'line-through text-gray-500': _unref(match).Status === _unref(MatchStatus).Void,
      }])
      }, [
        _createVNode(Participants, { participants: _unref(participants) }, null, 8, ["participants"])
      ], 2),
      (_unref(match).HasWinner)
        ? (_openBlock(), _createBlock(Winner, {
            key: 0,
            class: _normalizeClass({
          'line-through text-gray-500': _unref(match).Status === _unref(MatchStatus).Void,
        }),
            participants: _unref(participants),
            type: _unref(match).WinnerType,
            response: _unref(response),
            "correct-response": __props.correctResponse,
            disabled: __props.disabled || _unref(match).Status === _unref(MatchStatus).Void,
            points: _unref(match).WinnerPointValue
          }, null, 8, ["class", "participants", "type", "response", "correct-response", "disabled", "points"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(match).Questions, (extra) => {
        return (_openBlock(), _createBlock(Extra, {
          class: _normalizeClass({
        'line-through text-gray-500': _unref(match).Status === _unref(MatchStatus).Void,
      }),
          key: extra.QuestionId,
          extra: extra,
          "match-id": _unref(match).MatchId,
          participants: _unref(participants),
          disabled: __props.disabled || _unref(match).Status === _unref(MatchStatus).Void,
          points: _unref(match).ExtraPointValue,
          response: 
        _unref(response).Questions?.find((x) => x.QuestionId === extra.QuestionId)
      ,
          "correct-response": 
        __props.correctResponse.Questions.find((x) => x.QuestionId === extra.QuestionId)
      
        }, null, 8, ["class", "extra", "match-id", "participants", "disabled", "points", "response", "correct-response"]))
      }), 128)),
      _createVNode(PotentialScore, {
        score: _unref(matchScore),
        class: _normalizeClass({ 'line-through': _unref(match).Status === _unref(MatchStatus).Void })
      }, null, 8, ["score", "class"])
    ]),
    _: 1
  }, 8, ["title", "subtitle", "third", "status", "voided"]))
}
}

})